var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-input',{attrs:{"size":"sm","type":"date"},on:{"change":function($event){return _vm.$emit('change',$event)}},model:{value:(_vm.DateValue),callback:function ($$v) {_vm.DateValue=$$v},expression:"DateValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }